import { Controller } from "@hotwired/stimulus"

// The live clock on a running work group (assistants/_work_group): counts up
// from the group's first step. The chat re-renders on every poll, so this
// reads the start time the server rendered rather than keeping its own state.
export default class extends Controller {
    static targets = ["time"]
    static values = { started: String, running: Boolean }

    connect() {
        if (!this.runningValue || !this.hasTimeTarget) return
        this.tick()
        this.timer = setInterval(() => this.tick(), 1000)
    }

    disconnect() {
        clearInterval(this.timer)
    }

    tick() {
        const seconds = Math.max(0, Math.round((Date.now() - new Date(this.startedValue).getTime()) / 1000))
        this.timeTarget.textContent = seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`
    }
}
